export { JobTitle } from './job-title.component';
